class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.image-comparison__slider');
    this.afterImage = this.querySelector('.image-comparison__image--after');
    this.isResizing = false;
    this.position = 50;
  }

  connectedCallback() {
    if (this.slider && this.afterImage) {
      this.init();
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  init() {
    this.setPosition(this.position);
    this.addEventListeners();
  }

  setPosition(position) {
    this.position = position;
    if (this.afterImage) {
      this.afterImage.style.setProperty('--position', `${position}%`);
    }
    if (this.slider) {
      this.slider.style.left = `${position}%`;
    }
  }

  addEventListeners() {
    this.slider.addEventListener('mousedown', this.startResize.bind(this));
    document.addEventListener('mousemove', this.resize.bind(this));
    document.addEventListener('mouseup', this.stopResize.bind(this));

    this.slider.addEventListener('touchstart', this.startResize.bind(this));
    document.addEventListener('touchmove', this.resize.bind(this));
    document.addEventListener('touchend', this.stopResize.bind(this));
  }

  removeEventListeners() {
    this.slider.removeEventListener('mousedown', this.startResize.bind(this));
    document.removeEventListener('mousemove', this.resize.bind(this));
    document.removeEventListener('mouseup', this.stopResize.bind(this));

    this.slider.removeEventListener('touchstart', this.startResize.bind(this));
    document.removeEventListener('touchmove', this.resize.bind(this));
    document.removeEventListener('touchend', this.stopResize.bind(this));
  }

  startResize(e) {
    this.isResizing = true;
    e.preventDefault();
  }

  stopResize() {
    this.isResizing = false;
  }

  resize(e) {
    if (!this.isResizing) return;

    const rect = this.getBoundingClientRect();
    const x = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    const position = ((x - rect.left) / rect.width) * 100;

    this.setPosition(Math.min(Math.max(position, 0), 100));
  }
}

customElements.define('image-comparison', ImageComparison);
